module.exports = __webpack_public_path__ + "img/oxford-logo.7eadd0b7.png";